import { stockLine } from './Helpers';

export default {
  series: 1,
  data: stockLine,
};
